import { createAction, props } from '@ngrx/store';
import { CACHED_REQUEST_STATUS } from '../../classes/cached-request';

export const updateGetRequestInQueue = createAction(
    '[PaceOffline] update get request in queue',
    props<{ url: string; refreshStatus: CACHED_REQUEST_STATUS }>(),
);

export const addGetRequestsToQueue = createAction(
    '[PaceOffline] add Multiple request to queue',
    props<{ uriContent: string; requests: string[] }>(),
);

export const refreshAllRequests = createAction('[PaceOffline] refresh all requests', props<{ cacheFirst?: boolean }>());

export const refreshRequest = createAction('[PaceOffline] refresh specific request', props<{ url: string }>());

export const refreshPendingRequests = createAction('[PaceOffline] refresh pending requests');
